"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.keeperSchema = void 0;
const lodash_1 = __importDefault(require("lodash"));
const zod_1 = require("zod");
const template_1 = require("../utils/template");
/**
 *  Available properties for keeper operation (Not yet implemented)
 *  @internal
 *  @group Keeper
 */
exports.keeperSchema = zod_1.z
    .object({
    exec: zod_1.z.string(),
})
    .merge(zod_1.z
    .object({
    description: zod_1.z.string().describe('Description of the operation'),
    args: zod_1.z.array(zod_1.z.string()),
    env: zod_1.z.array(zod_1.z.string()),
    depends: zod_1.z
        .array(zod_1.z.string())
        .describe('List of operations that this operation depends on, which Cannon will execute first. If unspecified, Cannon automatically detects dependencies.'),
})
    .deepPartial());
// ensure the specified contract is already deployed
// if not deployed, deploy the specified hardhat contract with specfied options, export address, abi, etc.
// if already deployed, reexport deployment options for usage downstream and exit with no changes
exports.default = {
    label: 'keeper',
    validate: exports.keeperSchema,
    async getState(_runtime, ctx, config, packageState) {
        return [this.configInject(ctx, config, packageState)];
    },
    configInject(ctx, config) {
        config = lodash_1.default.cloneDeep(config);
        config.exec = (0, template_1.template)(config.exec, ctx);
        if (config.args) {
            config.args = lodash_1.default.map(config.args, (v) => {
                return (0, template_1.template)(v, ctx);
            });
        }
        if (config.env) {
            config.env = lodash_1.default.map(config.env, (v) => {
                return (0, template_1.template)(v, ctx);
            });
        }
        return config;
    },
    async exec() {
        return {};
    },
};
//# sourceMappingURL=keeper.js.map